<template>
  <div style="height: 600px;">
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">请输入要查询的经营许可证信息</span>
    </div>
    <div class="checkDL">
      <Input v-model="corpRoadTransport" placeholder="请输入经营许可证号" style="width: 200px;margin-left: 5px"/>
      <Input v-model="comp" placeholder="请输入企业名称" style="width: 200px;margin-left: 5px"/>
      <Button status="primary" icon="ios-search" style="margin-left: 10px;border-radius: 5px;" @click="commit">搜索</Button>
    </div>

    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">查询结果</span>
    </div>
    <div class="resultFour">{{resultFour}}</div>
  </div>
</template>
<script>
  import {apiGet, apiPost} from "../../utils/api";
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    name: 'checkERL',
    data() {
      return {
        comp: '',
        corpRoadTransport: '',
        resultFour: '',
      }
    },
    methods: {
      commit() {
        let self = this;
        //提示填写信息
        if (!this.corpRoadTransport || !this.comp) {
          this.$XModal.alert({
            message: '请输入完整信息！',
            status: "error",
          });
          return;
        }
        this.$XModal.confirm("请确认信息无误，确认后查询").then((type) => {
          if (type === "confirm") {
            this.enterpriseRoadLicenseV3();
          }
        });
      },
      async enterpriseRoadLicenseV3() {
        let params = {
          method: 'enterpriseRoadLicenseV3',
          params: {
            comp: this.comp,
            corpRoadTransport: this.corpRoadTransport,
          }
        }
        showLoading();
        let res = await apiPost("api/order/track/", params.method, params.params);
        hideLoading();
        if (res && res.status === 1) {
          let resData = JSON.parse(res.data)
          if (parseInt(resData.status) === 1001) {
            let data = resData.result;
            let code = parseInt(data.code);
            if (code === 10000) {
              let seqNo = data.seqNo ? data.seqNo : '';//序列号
              let enterpriseName = data.enterpriseName ? data.enterpriseName : '';//经营业户名称
              let customerAddressDetail = data.customerAddressDetail ? data.customerAddressDetail : '';//业户地址
              let operatingStatus = data.operatingStatus ? data.operatingStatus : '';//经营状态
              let roadLicense = data.roadLicense ? data.roadLicense : '';//经营许可证号
              let authStartTime = data.authStartTime ? data.authStartTime : '';//有效期起
              let authEndTime = data.authEndTime ? data.authEndTime : '';//有效期止
              let authDepartment = data.authDepartment ? data.authDepartment : '';//发证机关
              let vehicleBusinessScope = data.vehicleBusinessScope ? data.vehicleBusinessScope : '';//经营范围
              let organizationCode = data.organizationCode ? data.organizationCode : '';//企业组织机构代码
              let principalName = data.principalName ? data.principalName : '';//负责人姓名
              let assessmentTime = data.assessmentTime ? this.timestampToTime(parseInt(data.assessmentTime)) : '';//评估时间

              this.resultFour = "序列号：" + seqNo + '\n经营业户名称：' + enterpriseName + '\n业户地址：' + customerAddressDetail +
                '\n经营状态：' + operatingStatus + '\t\t经营许可证号：' + roadLicense + '\t\t有效期起:' + authStartTime + '\t\t有效期止:' + authEndTime +
                '\n发证机关:' + authDepartment + '\t\t经营范围:' + vehicleBusinessScope + '\t\t企业组织机构代码:' + organizationCode +
                '\n负责人姓名:' + principalName + '\t\t评估时间:' + assessmentTime;
            } else if (code === 10001) {
              this.resultFour = "查询无结果";
            } else if (code === 10002) {
              this.resultFour = "参数有误";
            } else if (code === 10003) {
              this.resultFour = "请求错误";
            } else if (code === 10004) {
              this.resultFour = "系统错误";
            }
          } else if (parseInt(resData.status) === 1006) {
            this.resultFour = "无结果";
          } else {
            this.resultFour = "查询错误";
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : '接口异常',
            status: "error",
          });
        }
      },
      timestampToTime(timestamp) {
        let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = date.getDate() < 10 ? ('0' + date.getDate()) + ' ' : date.getDate() + ' ';
        let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      },
    }
  }
</script>
<style scoped>
  .checkDL {
    height: 40%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }

  .resultFour {
    /*height: 20%;*/
    margin-top: 10px;
    line-height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
    white-space: pre;
  }
</style>